export default __webpack_public_path__ + "static/media/ic-loginimage.2431b03e.png";